import type { ResponseLanguage } from "../api/models";

export interface TtsFeatureConfig {
  enableVoiceSynthesis?: boolean;
  synthesisVoices?: Partial<Record<ResponseLanguage, string>>;
}

export const normalizeResponseLanguage = (value: unknown): ResponseLanguage | undefined => (
  value === "en" || value === "ga" ? value : undefined
);

export const getTtsVoiceForResponse = (
  features: TtsFeatureConfig,
  responseLanguage: ResponseLanguage | undefined,
): string | undefined => {
  if (!features.enableVoiceSynthesis || !responseLanguage) {
    return undefined;
  }

  const voice = features.synthesisVoices?.[responseLanguage]?.trim();
  return voice || undefined;
};
